import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import ura from './UserRequestCard.module.scss';
export const UserAsk = () => {
    const { t } = useTranslation('hotelierCabinet');
    return (_jsxs("div", { children: [_jsx("button", Object.assign({ className: ura.detail__houses_btn }, { children: "307" })), _jsxs("div", Object.assign({ className: ura.houses_block_close }, { children: [_jsx("div", Object.assign({ className: ura.houses_block_info1 }, { children: t('blockInfo1') })), _jsx("div", Object.assign({ className: ura.houses_block_info2 }, { children: t('blockInfo2') })), _jsx("div", { className: ura.houses_block_btn })] }))] }));
};
